/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-19",
    versionChannel: "nightly",
    buildDate: "2024-01-19T00:15:24.643Z",
    commitHash: "5f123c3c011b044670602c2b0bb986527fc57135",
};
